import styled from "styled-components";
import { PagesUserSearchUiInput } from "./Input";
import { PagesUserSearchUiResults } from "./Results";
import { Alert } from "@dealer-center/core-components";
import type { userSearchAPIInterface } from "@dealer-center/ddc-api-user-interface";

const StyledPagesUserSearchUi = styled.div`
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const StyledPageHeader = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1rem;
`;

interface PagesUserSearchUiDisplayProps {
  data?: userSearchAPIInterface;
  setName: (name: string) => void;
  nameInput: string;
  setNameInput: (name: string | undefined | number) => void;
  error: Error | null;
  loading: boolean;
}

export const PagesUserSearchUiDisplay = ({
  data,
  nameInput,
  setName,
  setNameInput,
  error,
  loading
}: PagesUserSearchUiDisplayProps) => {
  return (
    <StyledPagesUserSearchUi>
      <StyledPageHeader>User Search</StyledPageHeader>
      <Alert role="alert" sx={{ marginBottom: "16px" }} type={"info"}>
        <p>
          You can search for ControlCenter user information based on the
          original ControlCenter username.
        </p>
        <p>
          If the ControlCenter username is not mapped to a Bridge ID results
          will not be returned. This does not mean that the user does not exist.
        </p>
        <p>
          If you search for a Bridge ID or a ControlCenter username that match,
          results will be returned.
        </p>
      </Alert>
      <PagesUserSearchUiInput
        nameInput={nameInput}
        setName={setName}
        setNameInput={setNameInput}
      />
      <PagesUserSearchUiResults data={data} error={error} loading={loading} />
    </StyledPagesUserSearchUi>
  );
};
